import React, { useState, useEffect } from 'react';
import './ResultsPage.css'; // Assuming you create a specific CSS for this component
import { useLocation, useNavigate } from 'react-router-dom';
import topborder from '../assets/top_border_results.svg';


function ResultsPage() {
    const location = useLocation();
    const { score, totalQuestions } = location.state;
    const navigate = useNavigate();

    const [bottomBorderHeight, setBottomBorderHeight] = useState('0px');

    useEffect(() => {
        const updateBorderHeight = () => {
        const topBorder = document.querySelector('.top-border-results-img');
        if (topBorder) {
            setBottomBorderHeight(`${topBorder.offsetHeight}px`);
        }
        };

        // Call once to set initial height
        updateBorderHeight();

        // Add event listener to update height on window resize
        window.addEventListener('resize', updateBorderHeight);

        // Clean up the event listener when the component unmounts
        return () => {
        window.removeEventListener('resize', updateBorderHeight);
        };
    }, []);

    const messages = [
            "You've barely scratched the surface of the world of Prythian.",
            "It seems like Prythian still holds many secrets from you.",
            "A novice in the lore, but even Feyre started without the knowledge of the Fae.",
            "The whispers of the wind tell tales you've yet to grasp.",
            "The archives of Velaris await your study. There's much to learn.",
            "A commendable journey so far, but the path continues onward.",
            "Not bad at all! With a little more study, you could be a keeper of the Cauldron's secrets.",
            "Quite impressive! You're on your way to becoming a Prythian legend.",
            "Incredible work! Rhysand himself would be impressed.",
            "Nearly a master of the lore, the Inner Circle would be proud.",
            "A perfect score! Even the High Lords would seek your counsel."
        ];

        // Calculate which message to display based on the score range
    const index = (Math.floor(score));

    const message = messages[index];

    const onStart = () => {
        navigate('/');  // Correct way to use navigate inside a function
    };

    return (
        <div className="app-background">
            <div className='results-container'>
                <img className="top-border-results-img" src={topborder} alt="top border" />
                <h1>Your Score: {score}/{totalQuestions}!</h1>
                <p>{message}</p>
                <button onClick={onStart}>Play Again</button>
                <div className="bottom-border" style={{ height: bottomBorderHeight }}></div>
            </div>
        </div>
    );
}

export default ResultsPage;
